import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import LoginScreen from "@/pages/admin/LoginScreen";
import Subscribers from "@/pages/admin/Subscribers";
import ProductManager from "@/pages/admin/ProductManager";
import MediaManager from "@/pages/admin/MediaManager";
import ContentManager from "@/pages/admin/ContentManager";
import Orders from "@/pages/admin/Orders";
import DiscountManager from "@/pages/admin/DiscountManager";
import EmailsManager from "@/pages/admin/EmailsManager";
import DropCountdownManager from "@/pages/admin/DropCountdownManager";

const TABS = [
  { id: "subscribers", label: "Subscribers" },
  { id: "orders", label: "Orders" },
  { id: "products", label: "Products" },
  { id: "discounts", label: "Discounts" },
  { id: "emails", label: "Emails" },
  { id: "drop", label: "Drop" },
  { id: "media", label: "Media" },
  { id: "content", label: "Site Content" },
];

export default function Admin() {
  const [authed, setAuthed] = useState(!!localStorage.getItem("gg_token"));
  const [tab, setTab] = useState("subscribers");

  useEffect(() => {
    if (authed) {
      api.get("/auth/me").catch((err) => {
        if (err.response?.status === 401) {
          localStorage.removeItem("gg_token");
          setAuthed(false);
        }
      });
    }
  }, [authed]);

  const logout = () => {
    localStorage.removeItem("gg_token");
    setAuthed(false);
  };

  if (!authed) return <LoginScreen onAuthed={() => setAuthed(true)} />;

  const tabCls = (t) =>
    `px-4 py-2 text-sm uppercase tracking-widest border-2 transition-colors ${
      tab === t ? "bg-[#DFFF00] text-[#090909] border-[#DFFF00]" : "border-[#F2EFEB] hover:bg-[#F2EFEB]/10"
    }`;

  return (
    <div className="min-h-screen bg-[#090909] text-[#F2EFEB] font-mono-ui px-4 md:px-8 py-10" data-testid="admin-dashboard">
      <div className="flex items-center justify-between flex-wrap gap-4 border-b-2 border-[#F2EFEB] pb-6">
        <div>
          <p className="overline text-[#DFFF00]">Good Grief / Control</p>
          <h1 className="font-display text-4xl md:text-6xl leading-none mt-1">DASHBOARD</h1>
        </div>
        <button onClick={logout} data-testid="admin-logout-btn" className="border-2 border-[#FF2A00] text-[#FF2A00] px-4 py-2 text-sm hover:bg-[#FF2A00] hover:text-[#090909] transition-colors">Logout</button>
      </div>

      <div className="flex gap-3 my-8 flex-wrap">
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} data-testid={`tab-${t.id}`} className={tabCls(t.id)}>{t.label}</button>
        ))}
      </div>

      {tab === "subscribers" && <Subscribers />}
      {tab === "orders" && <Orders />}
      {tab === "products" && <ProductManager />}
      {tab === "discounts" && <DiscountManager />}
      {tab === "emails" && <EmailsManager />}
      {tab === "drop" && <DropCountdownManager />}
      {tab === "media" && <MediaManager />}
      {tab === "content" && <ContentManager />}
    </div>
  );
}
